import isEmpty from 'lodash/isEmpty';
import paymentTypeToCreditCardType from '../../utils/paymentTypeToCreditCardType';

export default function prepareCreditCardRequestBody(formData) {
  if (!formData.valid) {
    return null;
  }

  const result = {
    updateOption: {
      type: formData.type,
      expirationMonth: formData.expirationMonth,
      expirationYear: formData.expirationYear,
      clawback: formData.clawback,
    },
    address: {
      address1: formData.address1,
      city: formData.city,
      stateAbbreviation: formData.stateAbbreviation,
      countryAbbreviation: formData.countryAbbreviation,
      unit: formData.unit,
      phone: formData.phone,
      postalCode: formData.zipCode,
      firstName: formData.firstName,
      lastName: formData.lastName,
    },
  };

  if (isEmpty(formData.paymentOption)) {
    // creating new
    result.updateOption.creditCardType = paymentTypeToCreditCardType(formData.cardType);
    result.updateOption.creditCardNumber = formData.cardNumber.replace(/\s/g, '');
    result.addOption = result.updateOption;
    delete result.updateOption;
  } // else no need to send cardNumber

  return result;
}

/*
  https://contegixapp1.livenation.com/confluence/display/LT/Payment+Options+API#PaymentOptionsAPI-add_option

  {
  "addOption": {
    "type": "CREDIT",
    "creditCardType": "MC",
    "creditCardNumber": "5231535209686935",
    "expirationMonth": "4",
    "expirationYear": "2019",
    "clawback": "true"
  },
    "address": {
      "address1": "7060 Hollywood Blvd",
      "city": "Hollywood",
      "postalCode": "90027",
      "countryAbbreviation": "US",
      "stateAbbreviation": "CA",
      "unit": "S123",
      "firstName": "Tom",
      "lastName": "Jerry",
      "phone": "323000000"
    }
  }

  Required Fields
  type - CREDIT
  creditCardType - VISA, MC, AMEX, DISCOVER_NETWORK, DINERS
  creditCardNumber
  expirationMonth
  expirationYear
  address1
  city
  postalCode -
  countryAbbreviation - US, CA
  firstName
  lastName
  phone

  Optional Fields
  clawback - true, false
  stateAbbreviation - CA, NB, ...
  unit
  address2
  address3
  countryId
  stateIdtitle
  title
  middleName
 */
